module.exports = __webpack_public_path__ + "media/press/abajournal-faf37d88.png";